'use client';
import AppLayout from '@/components/AppLayout';
import CampaignDiscovery from './components/CampaignDiscovery';

export default function CampaignDiscoveryPage() {
  return (
    <AppLayout portalName="Investor Portal" portalRole="investor">
      <CampaignDiscovery />
    </AppLayout>
  );
}
